import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import { NotificationService } from '../../services/notification.service';
import { ConfigService } from '../../services/config.service';
import { RequestService } from '../../services/request.service';
import { UtilService } from 'app/core/services/util.service';
import { ModalService } from '../../services/modal.service';
import { AuthService } from 'app/core/services/auth.service';

@Component({
    selector: 'itpx-unsubscribe-user',
    templateUrl: './unsubscribe-user.component.html',
    styleUrls: [ './unsubscribe-user.component.css' ]
})

export class UnsubscribeUserComponent implements OnInit {

    private details: any = {};
    private sub: Subscription;

    constructor(
        private notificationService: NotificationService,
        private configService: ConfigService,
        private route: ActivatedRoute,
        private router: Router,
        private requestService: RequestService,
        private modal: ModalService,
        private authService: AuthService
    ) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.details.email = params['uuid'];
        });
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private save() {
        let url = this.configService.get('server').url + this.configService.get('endpoints').notificationManagement.blacklist.unsubscribe.api;
        
        this.requestService.post(url, {email: this.details.email})
                .subscribe(body => {
                    this.modal.info(
                        'Request Successful ',
                        "You've been successfully unsubscribed from Leapest e-mails. You will no longer receive e-mails from Leapest or its associated merchants."
                    ).subscribe(
                        event => {
                            this.authService.login();
                        });
                });
    }

    private cancel() {
        this.authService.login();
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/unsubscribe-user/unsubscribe-user.component.ts